// test1954
(1954 && 0);
